import { IPropertySmartSuggest } from './property-smartsuggest.model';
import { IPropertySmartSuggestion } from '.';

export interface IPropertyParameterModel {
  DemandId?: number
  DemandPersonId?: number
  Address?: string;
  Ids?: number[];
  PurposeIds?: number[];
  RegionEntries?: IPropertySmartSuggestion[];
  StatusIds?: number[];
  InputEntries?: IPropertySmartSuggest[];
  GoalId?: number;
  SiteIds?: number[];
  ConstructionTypes?: number[];
  ExcludeIds?: number[],
  FilterObject?: boolean;
  IsMediaSelected?: boolean;
  IsMediaStatistic?: boolean; //WA-2356 Media statistic 
  MediaFromDate?: string; //WA-2356 Media statistic
  MediaToDate?: string; //WA-2356 Media statistic
  IsDeleted?: boolean;
  MonthOfStartRent?: number; // WA-2863 Auto index
}
export class PropertyParameterModel implements IPropertyParameterModel {
  DemandId?: number
  DemandPersonId?: number
  Ids?: number[];
  StatusIds?: number[];
  PurposeIds?: number[];
  InputEntries?: IPropertySmartSuggest[];
  RegionEntries?: IPropertySmartSuggestion[];
  GoalId?: number;
  SiteIds?: number[];
  ConstructionTypes?: number[];
  ExcludeIds?: number[];
  FilterObject?: boolean = false;
  IsMediaSelected?: boolean = false;
  IsMediaStatistic?: boolean = false; 
  MediaFromDate?: string;
  MediaToDate?: string;
  MonthOfStartRent?: number;
  IsDeleted?: boolean = false;
  constructor(option?: IPropertyParameterModel) {
    this.StatusIds = option.StatusIds || [];
    this.GoalId = option.GoalId || null;
    this.InputEntries = option.InputEntries || [];
    this.RegionEntries = option.RegionEntries || [];
    this.PurposeIds = option.PurposeIds || [];
    this.Ids = option.Ids || [];
    this.SiteIds = option.SiteIds || [];
    this.ConstructionTypes = option.ConstructionTypes || [0];
    this.ExcludeIds = option.ExcludeIds || [];
    this.FilterObject = option.FilterObject || false;
    this.IsMediaSelected = option.IsMediaSelected || false;
    this.IsMediaStatistic = option.IsMediaStatistic || false;
    this.MediaFromDate = option.MediaFromDate || null;
    this.MediaToDate = option.MediaToDate || null;
    this.MonthOfStartRent = option.MonthOfStartRent || null;
    this.IsDeleted = option.IsDeleted || false;
  }
}